import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormValidationService {
  markAllAsTouched(form: any) {
    Object.keys(form.controls).forEach((field: any) => {
      if (form.get(field)['controls']) {
        this.markAllAsTouched(form.get(field));
      } else {
        form.get(field).markAsTouched({ onlySelf: true });
      }
    });
  }

  updateValueAndValidity(form: any) {
    Object.keys(form.controls).forEach((field: any) => {
      if (form.get(field)['controls']) {
        this.updateValueAndValidity(form.get(field));
      } else {
        form.get(field).updateValueAndValidity({ onlySelf: true });
      }
    });

    form.updateValueAndValidity();
  }
}
